/* INLOUVE — barre de collection mobile, Taste */
if (!customElements.get('inlouve-collection-mobile')) {
  customElements.define('inlouve-collection-mobile', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.shopify-section');
      if (!this.root || this.observer) return;

      this.columns = '2';

      try {
        const saved = sessionStorage.getItem('inlouve:collection-columns');

        if (saved === '1' || saved === '2') {
          this.columns = saved;
        }
      } catch (_) {
        /* Le stockage de la préférence est facultatif. */
      }

      this.mobile = matchMedia('(max-width: 749px)');
      this.sync = this.sync.bind(this);

      this.mobile.addEventListener('change', this.sync);

      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.root, {
        childList: true,
        subtree: true
      });

      this.sync();
    }

    sync() {
      if (!this.mobile.matches) return;

      const facets = this.root.querySelector(
        '#main-collection-filters .facets-container'
      );

      const nativeSort = this.root.querySelector('#SortBy-mobile');

      const drawer = facets?.querySelector(
        'menu-drawer.mobile-facets__wrapper'
      );

      if (
        !facets ||
        !nativeSort ||
        !drawer ||
        !this.querySelector('template')
      ) {
        return;
      }

      if (!this.controls?.isConnected) {
        this.controls = this.querySelector('template')
          .content.firstElementChild.cloneNode(true);

        drawer.after(this.controls);

        this.controls.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-columns]');

          if (!button || !this.mobile.matches) return;

          this.columns = button.dataset.columns;

          try {
            sessionStorage.setItem(
              'inlouve:collection-columns',
              this.columns
            );
          } catch (_) {
            /* Les boutons fonctionnent aussi sans stockage. */
          }

          this.sync();
        });

        this.controls.querySelector('select').addEventListener(
          'change',
          (event) => {
            const original = this.root.querySelector('#SortBy-mobile');

            if (!original || !this.mobile.matches) return;

            original.value = event.target.value;

            /* Réutilise le tri natif de Taste et ses filtres actifs. */
            original.dispatchEvent(
              new Event('input', { bubbles: true })
            );
          }
        );
      }

      const select = this.controls.querySelector('select');

      if (select.innerHTML !== nativeSort.innerHTML) {
        select.innerHTML = nativeSort.innerHTML;
      }

      select.value = nativeSort.value;

      this.controls.querySelectorAll('button[data-columns]').forEach(
        (button) => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.columns === this.columns)
          );
        }
      );

      this.root.dataset.inlouveMobile = this.columns;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.sync);
      this.controls?.remove();

      if (this.root) {
        delete this.root.dataset.inlouveMobile;
      }

      this.observer = null;
    }
  });
}